<!-- 移动端股东人数汇总数据展示组件 -->
<template>
	<div class="summary-columns">
		<div v-if="showTotalAccount" class="summary-item">
			<span class="summary-value">{{ computedTotalAccount.value }}</span>
			<span class="summary-label">
				{{ $t('enterprise.number-of-shareholders') }}({{ computedTotalAccount.unit }})
			</span>
		</div>
		<div v-if="showAverageHoldings" class="summary-item">
			<span class="summary-value">{{ computedTotalHoldings.value }}</span>
			<span class="summary-label">
				{{ $t('enterprise.average-holding') }}({{ computedTotalHoldings.unit }})
			</span>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { formatterColTransferUnit } from '@/utils/format';

// Props 定义
const props = defineProps({
	// 股东数据
	data: {
		type: Array,
		default: () => []
	},
	// 是否显示股东总数
	showTotalAccount: {
		type: [Boolean, Number, String],
		default: true
	},
	// 是否显示平均持股
	showAverageHoldings: {
		type: [Boolean, Number, String],
		default: true
	}
});

// 计算总股东数
const computedTotalAccount = computed(() => {
	const data = [...props.data];
	const total = data.reduce((prev, acc) => prev + acc.totalAccount, 0);
	return splitAmount(total);
});

// 计算总平均持股
const computedTotalHoldings = computed(() => {
	const data = [...props.data];
	const total = data.reduce((prev, acc) => prev + acc.averageHoldings, 0);
	return splitAmount(total);
});

// 格式化金额
const splitAmount = amount => {
	const [value, unit] = formatterColTransferUnit(amount, true);
	return { value, unit };
};
</script>

<style lang="less" scoped>
.summary-columns {
	display: flex;
	justify-content: space-between;
}

.summary-item {
	.summary-value {
		margin-right: 8px;
		color: var(--t-emphasis-color, #1d2129);
		font-family: 'DIN Alternate';
		font-size: 24px;
		font-weight: 700;
		line-height: 28px; /* 100% */
	}

	.summary-label {
		color: var(--t-secondary-info-color, #86909c);
		font-size: 13px;
		font-weight: 400;
		line-height: 20px; /* 153.846% */
	}
}
</style>
